import { Sprite } from "./Sprite";
import { Config } from "./../../Config";
import { Input } from "./Input";
import { TransformKind } from "./SpriteConst";
import { NodeFlags } from "../Const";
import { Event } from "../events/Event";
import { InputManager } from "../events/InputManager";
import { Matrix } from "../maths/Matrix";
import { Point } from "../maths/Point";
import { Render } from "../renders/Render";
import { RenderInfo } from "../renders/RenderInfo";
import { Browser } from "../utils/Browser";
import { ColorUtils } from "../utils/ColorUtils";
import { Stat } from "../utils/Stat";
import { ILaya } from "../../ILaya";
import { ComponentDriver } from "../components/ComponentDriver";
import { LayaEnv } from "../../LayaEnv";
import { Color } from "../maths/Color";
import { LayaGL } from "../layagl/LayaGL";
import { RenderState2D } from "../webgl/utils/RenderState2D";
import { Timer } from "../utils/Timer";
import { Tweener } from "../tween/Tweener";
export class Stage extends Sprite {
    constructor() {
        super();
        this.offset = new Point();
        this.designWidth = 0;
        this.designHeight = 0;
        this.canvasRotation = false;
        this.canvasDegree = 0;
        this.renderingEnabled = true;
        this.screenAdaptationEnabled = true;
        this._canvasTransform = new Matrix();
        this.useRetinalCanvas = false;
        this._scene3Ds = [];
        this._scene2Ds = [];
        this._frameRate = "fast";
        this._screenMode = "none";
        this._scaleMode = "noscale";
        this._alignV = "top";
        this._alignH = "left";
        this._bgColor = "gray";
        this._renderCount = 0;
        this._safariOffsetY = 0;
        this._frameStartTime = 0;
        this._globalRepaintSet = false;
        this._globalRepaintGet = false;
        this._wgColor = new Color(0, 0, 0, 0);
        this._needUpdateCanvasSize = false;
        this.mouseEnabled = true;
        this.hitTestPrior = true;
        this._setBit(NodeFlags.DISPLAYED_INSTAGE, true);
        this._setBit(NodeFlags.ACTIVE_INHIERARCHY, true);
        this._isFocused = true;
        this._isVisibility = true;
        this._transform = new Matrix();
        this.useRetinalCanvas = LayaEnv.isConch ? true : Config.useRetinalCanvas;
        this._previousOrientation = Browser.window.orientation;
        let window = Browser.window;
        window.addEventListener("focus", () => {
            this._isFocused = true;
            this.event(Event.FOCUS);
            this.event(Event.FOCUS_CHANGE);
        });
        window.addEventListener("blur", () => {
            this._isFocused = false;
            this.event(Event.BLUR);
            this.event(Event.FOCUS_CHANGE);
            if (this._isInputting())
                Input["inputElement"].target.focus = false;
        });
        var state = "visibilityState", visibilityChange = "visibilitychange";
        var document = window.document;
        if (typeof document.hidden !== "undefined") {
            visibilityChange = "visibilitychange";
            state = "visibilityState";
        }
        else if (typeof document.mozHidden !== "undefined") {
            visibilityChange = "mozvisibilitychange";
            state = "mozVisibilityState";
        }
        else if (typeof document.msHidden !== "undefined") {
            visibilityChange = "msvisibilitychange";
            state = "msVisibilityState";
        }
        else if (typeof document.webkitHidden !== "undefined") {
            visibilityChange = "webkitvisibilitychange";
            state = "webkitVisibilityState";
        }
        window.document.addEventListener(visibilityChange, () => {
            if (Browser.document[state] == "hidden") {
                this._isVisibility = false;
                if (this._isInputting())
                    Input["inputElement"].target.focus = false;
            }
            else {
                this._isVisibility = true;
            }
            this.renderingEnabled = this._isVisibility;
            this.event(Event.VISIBILITY_CHANGE);
        });
        window.addEventListener("resize", () => {
            var orientation = Browser.window.orientation;
            if (orientation != null && orientation != this._previousOrientation && this._isInputting()) {
                Input["inputElement"].target.focus = false;
            }
            this._previousOrientation = orientation;
            if (this._isInputting())
                return;
            if (Browser.onSafari)
                this._safariOffsetY = Browser.getSafariToolbarOffset();
            if (this.screenAdaptationEnabled) {
                this.event(Event.WILL_RESIZE);
                this.updateCanvasSize(true);
            }
        });
        window.addEventListener("orientationchange", (e) => {
            if (this.screenAdaptationEnabled) {
                this.event(Event.WILL_RESIZE);
                this.updateCanvasSize(true);
            }
        });
        this._componentDriver = new ComponentDriver();
    }
    _isInputting() {
        return (Browser.onMobile && Input.isInputting);
    }
    _transChanged(kind) {
        super._transChanged(kind);
        if ((kind & TransformKind.Size) != 0) {
            this.designWidth = this._width;
            this.designHeight = this._height;
            this.updateCanvasSize(true);
        }
    }
    measureWidth() {
        this.needUpdateCanvasSize();
        return this._width;
    }
    measureHeight() {
        this.needUpdateCanvasSize();
        return this._height;
    }
    get isFocused() {
        return this._isFocused;
    }
    get isVisibility() {
        return this._isVisibility;
    }
    updateCanvasSize(delay) {
        if (delay) {
            if (!this._needUpdateCanvasSize) {
                this._needUpdateCanvasSize = true;
                ILaya.systemTimer.callLater(this, this.updateCanvasSize);
            }
        }
        else {
            this.setScreenSize(Browser.clientWidth * Browser.pixelRatio, Browser.clientHeight * Browser.pixelRatio);
        }
    }
    needUpdateCanvasSize() {
        if (this._needUpdateCanvasSize)
            this.updateCanvasSize();
    }
    setScreenSize(screenWidth, screenHeight) {
        var _a;
        this._needUpdateCanvasSize = false;
        var rotation = false;
        if (this._screenMode !== Stage.SCREEN_NONE) {
            var screenType = screenWidth / screenHeight < 1 ? Stage.SCREEN_VERTICAL : Stage.SCREEN_HORIZONTAL;
            rotation = screenType !== this._screenMode;
            if (rotation) {
                var temp = screenHeight;
                screenHeight = screenWidth;
                screenWidth = temp;
            }
        }
        this.canvasRotation = rotation;
        var canvas = Render._mainCanvas;
        var mat = this._canvasTransform.identity();
        var scaleMode = this._scaleMode;
        var scaleX = screenWidth / this.designWidth;
        var scaleY = screenHeight / this.designHeight;
        var canvasWidth = this.useRetinalCanvas ? screenWidth : this.designWidth;
        var canvasHeight = this.useRetinalCanvas ? screenHeight : this.designHeight;
        var realWidth = screenWidth;
        var realHeight = screenHeight;
        var pixelRatio = Browser.pixelRatio;
        this._width = this.designWidth;
        this._height = this.designHeight;
        switch (scaleMode) {
            case Stage.SCALE_NOSCALE:
                scaleX = scaleY = 1;
                realWidth = this.designWidth;
                realHeight = this.designHeight;
                break;
            case Stage.SCALE_SHOWALL:
                scaleX = scaleY = Math.min(scaleX, scaleY);
                realWidth = Math.round(this.designWidth * scaleX);
                realHeight = Math.round(this.designHeight * scaleY);
                break;
            case Stage.SCALE_NOBORDER:
                scaleX = scaleY = Math.max(scaleX, scaleY);
                realWidth = Math.round(this.designWidth * scaleX);
                realHeight = Math.round(this.designHeight * scaleY);
                break;
            case Stage.SCALE_FULL:
                scaleX = scaleY = 1;
                this._width = canvasWidth = screenWidth;
                this._height = canvasHeight = screenHeight;
                break;
            case Stage.SCALE_FULLSCREEN:
                scaleX = scaleY = pixelRatio;
                canvasWidth = screenWidth;
                canvasHeight = screenHeight;
                this._width = screenWidth / pixelRatio;
                this._height = screenHeight / pixelRatio;
                break;
            case Stage.SCALE_FIXED_WIDTH:
                scaleY = scaleX;
                this._height = canvasHeight = Math.round(screenHeight / scaleX);
                break;
            case Stage.SCALE_FIXED_HEIGHT:
                scaleX = scaleY;
                this._width = canvasWidth = Math.round(screenWidth / scaleY);
                break;
            case Stage.SCALE_FIXED_AUTO:
                if ((screenWidth / screenHeight) < (this.designWidth / this.designHeight)) {
                    scaleY = scaleX;
                    this._height = canvasHeight = Math.round(screenHeight / scaleX);
                }
                else {
                    scaleX = scaleY;
                    this._width = canvasWidth = Math.round(screenWidth / scaleY);
                }
                break;
        }
        if (this.useRetinalCanvas) {
            if (scaleMode === Stage.SCALE_SHOWALL || scaleMode === Stage.SCALE_NOSCALE) {
                canvasWidth = realWidth;
                canvasHeight = realHeight;
            }
            else {
                canvasWidth = realWidth = screenWidth;
                canvasHeight = realHeight = screenHeight;
            }
        }
        scaleX *= this.scaleX;
        scaleY *= this.scaleY;
        if (scaleX === 1 && scaleY === 1) {
            this.transform.identity();
        }
        else {
            this.transform.a = this._formatData(scaleX / (realWidth / canvasWidth));
            this.transform.d = this._formatData(scaleY / (realHeight / canvasHeight));
        }
        canvas.size(canvasWidth, canvasHeight);
        mat.scale(realWidth / canvasWidth / pixelRatio, realHeight / canvasHeight / pixelRatio);
        if (this._alignH === Stage.ALIGN_LEFT)
            this.offset.x = 0;
        else if (this._alignH === Stage.ALIGN_RIGHT)
            this.offset.x = screenWidth - realWidth;
        else
            this.offset.x = (screenWidth - realWidth) * 0.5 / pixelRatio;
        if (this._alignV === Stage.ALIGN_TOP)
            this.offset.y = 0;
        else if (this._alignV === Stage.ALIGN_BOTTOM)
            this.offset.y = screenHeight - realHeight;
        else
            this.offset.y = (screenHeight - realHeight) * 0.5 / pixelRatio;
        this.offset.x = Math.round(this.offset.x);
        this.offset.y = Math.round(this.offset.y);
        mat.translate(this.offset.x, this.offset.y);
        if (this._safariOffsetY)
            mat.translate(0, this._safariOffsetY);
        this.canvasDegree = 0;
        if (rotation) {
            if (this._screenMode === Stage.SCREEN_HORIZONTAL) {
                mat.rotate(Math.PI / 2);
                mat.translate(screenHeight / pixelRatio, 0);
                this.canvasDegree = 90;
            }
            else {
                mat.rotate(-Math.PI / 2);
                mat.translate(0, screenWidth / pixelRatio);
                this.canvasDegree = -90;
            }
        }
        mat.a = this._formatData(mat.a);
        mat.d = this._formatData(mat.d);
        mat.tx = this._formatData(mat.tx);
        mat.ty = this._formatData(mat.ty);
        this.transform = this.transform;
        Stage._setStageStyle(canvas, canvasWidth, canvasHeight, mat);
        if (this._safariOffsetY)
            mat.translate(0, -this._safariOffsetY);
        RenderState2D.width = canvasWidth;
        RenderState2D.height = canvasHeight;
        (_a = window['Laya3D']) === null || _a === void 0 ? void 0 : _a._changeWebGLSize(canvasWidth, canvasHeight);
        LayaGL.renderEngine.resizeOffScreen(canvasWidth, canvasHeight);
        this.visible = true;
        this.repaint();
        this.event(Event.RESIZE);
    }
    static _setStageStyle(mainCanv, canvasWidth, canvasHeight, mat) {
        var canvasStyle = mainCanv.source.style;
        canvasStyle.transformOrigin = canvasStyle.webkitTransformOrigin = canvasStyle.msTransformOrigin = canvasStyle.mozTransformOrigin = canvasStyle.oTransformOrigin = "0px 0px 0px";
        canvasStyle.transform = canvasStyle.webkitTransform = canvasStyle.msTransform = canvasStyle.mozTransform = canvasStyle.oTransform = "matrix(" + mat.toString() + ")";
        canvasStyle.width = canvasWidth;
        canvasStyle.height = canvasHeight;
        mat.translate(parseInt(canvasStyle.left) || 0, parseInt(canvasStyle.top) || 0);
    }
    setScreenSizeForScene(screenWidth, screenHeight, screenMode) {
        var rotation = false;
        if (screenMode !== Stage.SCREEN_NONE) {
            var screenType = screenWidth / screenHeight < 1 ? Stage.SCREEN_VERTICAL : Stage.SCREEN_HORIZONTAL;
            rotation = screenType !== screenMode;
            if (rotation) {
                var temp = screenHeight;
                screenHeight = screenWidth;
                screenWidth = temp;
            }
        }
        this.canvasRotation = rotation;
        var scaleMode = this._scaleMode;
        var scaleX = screenWidth / this.designWidth;
        var scaleY = screenHeight / this.designHeight;
        var canvasWidth = this.useRetinalCanvas ? screenWidth : this.designWidth;
        var canvasHeight = this.useRetinalCanvas ? screenHeight : this.designHeight;
        var realWidth = screenWidth;
        var realHeight = screenHeight;
        let _width = this.designWidth;
        let _height = this.designHeight;
        switch (scaleMode) {
            case Stage.SCALE_NOSCALE:
                scaleX = scaleY = 1;
                realWidth = this.designWidth;
                realHeight = this.designHeight;
                break;
            case Stage.SCALE_SHOWALL:
                scaleX = scaleY = Math.min(scaleX, scaleY);
                realWidth = Math.round(this.designWidth * scaleX);
                realHeight = Math.round(this.designHeight * scaleY);
                break;
            case Stage.SCALE_NOBORDER:
                scaleX = scaleY = Math.max(scaleX, scaleY);
                realWidth = Math.round(this.designWidth * scaleX);
                realHeight = Math.round(this.designHeight * scaleY);
                break;
            case Stage.SCALE_FULL:
                scaleX = scaleY = 1;
                _width = canvasWidth = screenWidth;
                _height = canvasHeight = screenHeight;
                break;
            case Stage.SCALE_FIXED_WIDTH:
                scaleY = scaleX;
                _height = canvasHeight = Math.round(screenHeight / scaleX);
                break;
            case Stage.SCALE_FIXED_HEIGHT:
                scaleX = scaleY;
                _width = canvasWidth = Math.round(screenWidth / scaleY);
                break;
            case Stage.SCALE_FIXED_AUTO:
                if ((screenWidth / screenHeight) < (this.designWidth / this.designHeight)) {
                    scaleY = scaleX;
                    _height = canvasHeight = Math.round(screenHeight / scaleX);
                }
                else {
                    scaleX = scaleY;
                    _width = canvasWidth = Math.round(screenWidth / scaleY);
                }
                break;
        }
        if (this.useRetinalCanvas) {
            if (scaleMode === Stage.SCALE_SHOWALL || scaleMode === Stage.SCALE_NOSCALE) {
                canvasWidth = realWidth;
                canvasHeight = realHeight;
            }
            else {
                canvasWidth = realWidth = screenWidth;
                canvasHeight = realHeight = screenHeight;
            }
        }
        return {
            stageWidth: _width,
            stageHeight: _height,
            canvasWidth: canvasWidth,
            canvasHeight: canvasHeight,
            scaleX: scaleX / (realWidth / canvasWidth),
            scaleY: scaleY / (realHeight / canvasHeight),
        };
    }
    _formatData(value) {
        if (Math.abs(value) < 0.000001)
            return 0;
        if (Math.abs(1 - value) < 0.001)
            return value > 0 ? 1 : -1;
        return value;
    }
    get scaleMode() {
        return this._scaleMode;
    }
    set scaleMode(value) {
        this._scaleMode = value;
        this.updateCanvasSize(true);
    }
    get alignH() {
        this.needUpdateCanvasSize();
        return this._alignH;
    }
    set alignH(value) {
        this._alignH = value;
        this.updateCanvasSize(true);
    }
    get alignV() {
        this.needUpdateCanvasSize();
        return this._alignV;
    }
    set alignV(value) {
        this._alignV = value;
        this.updateCanvasSize(true);
    }
    get bgColor() {
        return this._bgColor;
    }
    set bgColor(value) {
        this._bgColor = value;
        if (value) {
            let colorArr = ColorUtils.create(value).arrColor;
            this._wgColor.setValue(colorArr[0], colorArr[1], colorArr[2], colorArr[3]);
        }
        else
            this._wgColor = null;
        Stage._setStyleBgColor(value);
    }
    static _setStyleBgColor(value) {
        if (value) {
            Render.canvas.style.background = value;
        }
        else {
            Render.canvas.style.background = "none";
        }
    }
    get mouseX() {
        return Math.round(InputManager.mouseX / this.clientScaleX);
    }
    get mouseY() {
        return Math.round(InputManager.mouseY / this.clientScaleY);
    }
    getMousePoint() {
        return Point.TEMP.setTo(this.mouseX, this.mouseY);
    }
    get clientScaleX() {
        this.needUpdateCanvasSize();
        return this._transform ? this._transform.getScaleX() : 1;
    }
    get clientScaleY() {
        this.needUpdateCanvasSize();
        return this._transform ? this._transform.getScaleY() : 1;
    }
    get screenMode() {
        return this._screenMode;
    }
    set screenMode(value) {
        this._screenMode = value;
    }
    _loop() {
        this._globalRepaintGet = this._globalRepaintSet;
        this._globalRepaintSet = false;
        this.render(Render._context, 0, 0);
        return true;
    }
    getFrameTm() {
        return this._frameStartTime;
    }
    getTimeFromFrameStart() {
        return Browser.now() - this._frameStartTime;
    }
    get visible() {
        return super.visible;
    }
    set visible(value) {
        super.visible = value;
        Stage._setVisibleStyle(value);
    }
    static _setVisibleStyle(value) {
        var style = Render._mainCanvas.source.style;
        style.visibility = value ? "visible" : "hidden";
    }
    render(context2D, x, y) {
        if (this._frameRate === Stage.FRAME_SLEEP) {
            var now = Browser.now();
            if (now - this._frameStartTime < 1000)
                return;
            this._frameStartTime = now;
        }
        else {
            if (!this._visible) {
                this._renderCount++;
                if (this._renderCount % 5 === 0) {
                    Timer.callLaters._update();
                    Stat.loopCount++;
                    RenderInfo.loopCount = Stat.loopCount;
                    this._runComponents();
                    this._updateTimers();
                }
                return;
            }
            this._frameStartTime = Browser.now();
            RenderInfo.loopStTm = this._frameStartTime;
        }
        this._renderCount++;
        let frameMode = this._frameRate === Stage.FRAME_MOUSE ? (((this._frameStartTime - InputManager.lastMouseTime) < 2000) ? Stage.FRAME_FAST : Stage.FRAME_SLOW) : this._frameRate;
        let isFastMode = (frameMode !== Stage.FRAME_SLOW);
        let isDoubleLoop = (this._renderCount % 2 === 0);
        Stat.renderSlow = !isFastMode;
        if (!isFastMode && !isDoubleLoop)
            return;
        Timer.callLaters._update();
        Stat.loopCount++;
        RenderInfo.loopCount = Stat.loopCount;
        LayaGL.renderEngine.startFrame();
        if (this.renderingEnabled) {
            for (let i = 0, n = this._scene2Ds.length; i < n; i++) {
                this._scene2Ds[i]._update();
            }
            for (let i = 0, n = this._scene3Ds.length; i < n; i++)
                this._scene3Ds[i]._update();
            this._runComponents();
            this._componentDriver.callPreRender();
            context2D.render2D.renderStart(!Config.preserveDrawingBuffer, this._wgColor);
            for (let i = 0, n = this._scene3Ds.length; i < n; i++)
                this._scene3Ds[i].renderSubmit();
            this._render2d(context2D, x, y);
            this._componentDriver.callPostRender();
        }
        else
            this._runComponents();
        this._updateTimers();
        LayaGL.renderEngine.endFrame();
    }
    _render2d(context2D, x, y) {
        Stat.draw2D = 0;
        context2D.startRender();
        super.render(context2D, x, y);
        Stat.render(context2D, x, y);
        context2D.endRender();
    }
    _runComponents() {
        this._componentDriver.callStart();
        this._componentDriver.callUpdate();
        this._componentDriver.callLateUpdate();
        this._componentDriver.callDestroy();
    }
    _updateTimers() {
        ILaya.systemTimer._update();
        ILaya.physicsTimer._update();
        ILaya.timer._update();
        Tweener._runAll();
    }
    set fullScreenEnabled(value) {
        var document = Browser.document;
        var canvas = Render.canvas;
        if (value) {
            canvas.addEventListener('mousedown', requestFullscreen);
            canvas.addEventListener('touchstart', requestFullscreen);
            document.addEventListener("fullscreenchange", fullScreenChanged);
            document.addEventListener("mozfullscreenchange", fullScreenChanged);
            document.addEventListener("webkitfullscreenchange", fullScreenChanged);
            document.addEventListener("msfullscreenchange", fullScreenChanged);
        }
        else {
            canvas.removeEventListener('mousedown', requestFullscreen);
            canvas.removeEventListener('touchstart', requestFullscreen);
            document.removeEventListener("fullscreenchange", fullScreenChanged);
            document.removeEventListener("mozfullscreenchange", fullScreenChanged);
            document.removeEventListener("webkitfullscreenchange", fullScreenChanged);
            document.removeEventListener("msfullscreenchange", fullScreenChanged);
        }
    }
    exitFullscreen() {
        var document = Browser.document;
        if (document.exitFullscreen) {
            document.exitFullscreen();
        }
        else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        }
        else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        }
    }
    get frameRate() {
        return this._frameRate;
    }
    set frameRate(value) {
        this._frameRate = value;
    }
    isGlobalRepaint() {
        return this._globalRepaintGet;
    }
    setGlobalRepaint() {
        this._globalRepaintSet = true;
    }
}
Stage.SCALE_NOSCALE = "noscale";
Stage.SCALE_SHOWALL = "showall";
Stage.SCALE_NOBORDER = "noborder";
Stage.SCALE_FULL = "full";
Stage.SCALE_FULLSCREEN = "fullscreen";
Stage.SCALE_FIXED_WIDTH = "fixedwidth";
Stage.SCALE_FIXED_HEIGHT = "fixedheight";
Stage.SCALE_FIXED_AUTO = "fixedauto";
Stage.ALIGN_LEFT = "left";
Stage.ALIGN_RIGHT = "right";
Stage.ALIGN_CENTER = "center";
Stage.ALIGN_TOP = "top";
Stage.ALIGN_MIDDLE = "middle";
Stage.ALIGN_BOTTOM = "bottom";
Stage.SCREEN_NONE = "none";
Stage.SCREEN_HORIZONTAL = "horizontal";
Stage.SCREEN_VERTICAL = "vertical";
Stage.FRAME_FAST = "fast";
Stage.FRAME_SLOW = "slow";
Stage.FRAME_MOUSE = "mouse";
Stage.FRAME_SLEEP = "sleep";
function requestFullscreen() {
    var element = Browser.document.documentElement;
    if (element.requestFullscreen) {
        element.requestFullscreen();
    }
    else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
    }
    else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
    }
    else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
    }
    var canvas = Render.canvas;
    canvas.removeEventListener('mousedown', requestFullscreen);
    canvas.removeEventListener('touchstart', requestFullscreen);
}
function fullScreenChanged() {
    ILaya.stage.event(Event.FULL_SCREEN_CHANGE);
}
